module.exports = __webpack_public_path__ + "img/nine-bg.34e78ba5.jpg";